module.exports = __webpack_public_path__ + "static/images/logo.fde91544.jpg";